import { render, staticRenderFns } from "./TaskCard.vue?vue&type=template&id=7f9779f8&scoped=true"
import script from "./TaskCard.vue?vue&type=script&lang=ts"
export * from "./TaskCard.vue?vue&type=script&lang=ts"
import style0 from "./TaskCard.vue?vue&type=style&index=0&id=7f9779f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9779f8",
  null
  
)

export default component.exports